import { TextButton } from '@components/core-ui/form-elements/buttons/Button/variations/TextButton';
import { triggerBrowserDownload } from '@helpers/jobLinkHelpers';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { LayoutsService } from 'app/API';
import toast from 'react-hot-toast';
import { buildLayoutDownloadFileName, TLayoutFileKind } from '../../../../../../helpers/buildLayoutDownloadFileName';
import { TProps } from './types/TProps';

export const LayoutDownloads = ({ layoutId, layoutName }: TProps) => {
  const { call } = useAPI();
  const downloadMutation = useMutation({
    mutationFn: async (kind: TLayoutFileKind) => {
      const urls = await call(() => LayoutsService.getDownloadUrlsForLayout({ layoutId }));
      return kind === 'docx' ? urls.docxDownloadLink : urls.jsonDownloadLink;
    },
    onSuccess: (url, kind) => {
      if (!url) {
        toast.error(`No ${kind.toUpperCase()} file is stored for this layout.`);
        return;
      }
      triggerBrowserDownload(url, buildLayoutDownloadFileName(layoutName, kind));
    },
    onError: () => {
      toast.error('Failed to fetch the layout download link. Please try again.');
    },
  });

  return (
    <div className="layout-links">
      <TextButton type="button" disabled={downloadMutation.isPending} onClick={() => downloadMutation.mutate('docx')}>
        Download DOCX
      </TextButton>
      <TextButton type="button" disabled={downloadMutation.isPending} onClick={() => downloadMutation.mutate('json')}>
        Download JSON
      </TextButton>
    </div>
  );
};
